import { useEffect, useRef } from "react";
import { useCurrentUser } from "@/features/account/useCurrentUser";
import { useTheme } from "./ThemeProvider";
import { isThemePreference } from "./theme";

/**
 * Adopts the signed-in user's saved theme (user.settings.theme) once per
 * identity, so it follows them across devices. Later changes flow the other
 * way (AppearancePage saves them), so this never fights the user.
 */
export function ThemeSync() {
  const me = useCurrentUser();
  const { setPreference } = useTheme();
  const syncedFor = useRef<string | null>(null);
  const uuid = me.data?.user.uuid;
  const saved = me.data?.user.settings?.theme;

  useEffect(() => {
    if (!uuid || syncedFor.current === uuid) return;
    syncedFor.current = uuid;
    if (isThemePreference(saved)) setPreference(saved);
  }, [uuid, saved, setPreference]);

  return null;
}
